import React, { Component } from "react";
import * as d3 from "d3";
import Loading from "../Loading";

// Chart dimensions
var width = 700;
var height = 700;
var radius = Math.min(width, height) / 2;
var color = d3.scaleOrdinal(d3.schemeCategory20b);

// Legend
var legendRectSize = 18;
var legendSpacing = 4;

// Donut Chart
var donutWidth = 80;

export default class PieView extends Component {
  componentWillMount() {
    this.props.authFetchWorkorders("teamwork/pieData", this.props.token.jwt);
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.isLoading) {
      console.log("calling renderChart");
      this.renderChart(nextProps.workOrders, this.props.performRoute);
    }
  }

  renderChart = (companys, performRoute) => {
    const time = companys.map((company) => {
      let minutes = company.tasks.map((task) => {
        return parseInt(task.estimatedMinutes);
      });
      let timeEstimate =
        minutes.length > 0 ? minutes.reduce((a, b) => a + b) : 0;

      return {
        id: company.id,
        label: company.name,
        count: timeEstimate,
        enabled: true,
      };
    });

    var svg = d3.select("#chart");
    svg.selectAll("*").remove();

    var svg = d3
      .select("#chart")
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
    var arc = d3
      .arc()
      //.innerRadius(0)
      .innerRadius(radius - donutWidth) // UPDATED
      .outerRadius(radius);
    var pie = d3
      .pie()
      .value(function (d) {
        return d.count;
      })
      .sort(null);
    var path = svg
      .selectAll("path")
      .data(pie(time))
      .enter()
      .append("path")
      .attr("d", arc)
      .attr("fill", function (d, i) {
        return color(d.data.label);
      })
      .each(function (d) {
        this._current = d;
      }); // NEW

    // Legend
    var legend = svg
      .selectAll(".legend")
      .data(color.domain())
      .enter()
      .append("g")
      .attr("class", "legend")
      .attr("transform", function (d, i) {
        var height = legendRectSize + legendSpacing;
        var offset = (height * color.domain().length) / 2;
        var horz = -3 * legendRectSize;
        var vert = i * height - offset;
        return "translate(" + horz + "," + vert + ")";
      });
    legend
      .append("rect")
      .attr("width", legendRectSize)
      .attr("height", legendRectSize)
      .style("fill", color)
      .style("stroke", color)
      .on("click", function (label) {
        var rect = d3.select(this);
        var enabled = true;
        var totalEnabled = d3.sum(
          time.map(function (d) {
            return d.enabled ? 1 : 0;
          }),
        );

        if (rect.attr("class") === "disabled") {
          rect.attr("class", "");
        } else {
          if (totalEnabled < 2) return;
          rect.attr("class", "disabled");
          enabled = false;
        }
        pie.value(function (d) {
          if (d.label === label) d.enabled = enabled;
          return d.enabled ? d.count : 0;
        });

        path = path.data(pie(time));
        path
          .transition()
          .duration(750)
          .attrTween("d", function (d) {
            var interpolate = d3.interpolate(this._current, d);
            this._current = interpolate(0);
            return function (t) {
              return arc(interpolate(t));
            };
          });
      });
    legend
      .append("text")
      .attr("x", legendRectSize + legendSpacing)
      .attr("y", legendRectSize - legendSpacing)
      .text(function (d) {
        return d;
      });

    // Tooltip
    var tooltip = d3.select("#chart").append("div").attr("class", "tooltip");
    tooltip.append("div").attr("class", "label");
    tooltip.append("div").attr("class", "count");
    tooltip.append("div").attr("class", "percent");

    // Path Mouse Events
    path.on("mouseover", function (d) {
      var total = d3.sum(
        time.map(function (d) {
          return d.enabled ? d.count : 0;
        }),
      );
      var percent = Math.round((1000 * d.data.count) / total) / 10;
      tooltip.select(".label").html(d.data.label);
      tooltip.select(".count").html(d.data.count);
      tooltip.select(".percent").html(percent + "%");
      tooltip.style("display", "block");
    });
    path.on("mouseout", function () {
      tooltip.style("display", "none");
    });
    path.on("click", function (d) {
      // console.log(d);
      performRoute(`/job/teamwork/companies/${d.data.id}`);
    });
  };

  render() {
    return (
      <div className="container">
        <br />
        <center>
          <div ref="chart" id="chart"></div>
        </center>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/teamwork/PieView.js